export type Goals =
  | 'converted files'
  | 'convert more'
  | 'converted with errors'
  | 'dislike'
  | 'like'
  | 'missed download'
  | 'unsupported browser'
  | 'consent set';

export class PlEvent extends Event {
  constructor(public plEventData: { goal: Goals; props?: any }) {
    super('86b19c2b-9f2e-481e-b042-e3bf84700d2a');
  }
}
